import styled, { css } from 'styled-components';

import { size } from '../../layout/helpers';

interface FormProps {
  $narrow?: boolean;
}

export const Form = styled.div<FormProps>`
  --gap: ${size(1.5)};
  --column-count: 2;

  // Calculcated values
  --gap-count: calc(var(--column-count) - 1);
  --total-gap-width: calc(var(--gap-count) * var(--gap));
  --max-width: calc((100% - var(--total-gap-width)) / var(--column-count));
  --min-width: 250px;

  display: grid;
  grid-template-columns: repeat(
    auto-fill,
    minmax(max(min(var(--min-width), 250px), var(--max-width)), 1fr)
  );
  gap: var(--gap);

  ${({ $narrow }) =>
    $narrow &&
    css`
      --min-width: 150px;
    `}
`;

export interface FormGroupProps {
  $width?: 'half';
}

export const FormGroup = styled.div<FormGroupProps>`
  ${({ $width }) =>
    $width === 'half'
      ? css`
          grid-column: span 1;
        `
      : css`
          grid-column: 1 / -1;
        `}
`;
